import { render, staticRenderFns } from "./ProjectArtifact.vue?vue&type=template&id=9027fe5c"
import script from "./ProjectArtifact.vue?vue&type=script&lang=js"
export * from "./ProjectArtifact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports